var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    rx: 12.5,
    fill: "#F7FAFC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0416 7.2812L17.7183 8.95715L16.0416 7.2812ZM17.1198 5.80474L12.586 10.3386C12.3517 10.5725 12.1919 10.8706 12.1268 11.1952L11.708 13.2915L13.8043 12.8719C14.1289 12.807 14.4266 12.6479 14.6609 12.4136L19.1948 7.8797C19.331 7.74345 19.4391 7.58171 19.5129 7.4037C19.5866 7.22569 19.6245 7.03489 19.6245 6.84222C19.6245 6.64954 19.5866 6.45875 19.5129 6.28074C19.4391 6.10273 19.331 5.94098 19.1948 5.80474C19.0586 5.66849 18.8968 5.56042 18.7188 5.48669C18.5408 5.41295 18.35 5.375 18.1573 5.375C17.9646 5.375 17.7739 5.41295 17.5958 5.48669C17.4178 5.56042 17.2561 5.66849 17.1198 5.80474V5.80474Z",
    stroke: "#2D3748",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0415 14.8747V17.2497C18.0415 17.6696 17.8747 18.0723 17.5778 18.3693C17.2808 18.6662 16.8781 18.833 16.4582 18.833H7.74984C7.32991 18.833 6.92718 18.6662 6.63025 18.3693C6.33332 18.0723 6.1665 17.6696 6.1665 17.2497V8.54134C6.1665 8.12142 6.33332 7.71869 6.63025 7.42176C6.92718 7.12482 7.32991 6.95801 7.74984 6.95801H10.1248",
    stroke: "#2D3748",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatEdit);
export default __webpack_public_path__ + "static/media/ChatEdit.979371169f80e27b30491e47ead81eb2.svg";
export { ForwardRef as ReactComponent };